// Оцветяване на съвпадналите думи в резултат на търсачка — ЕДНО място за целия
// модул (беше дублирано дословно в `deliveryWorksheetShared`,
// `writeoffWorksheetShared` и `stocktakeWorksheetShared`, които вече само го
// пре-експортират, за да не се пипат импортите им).
//
// Търсенето е многодумно: всяка дума се маркира навсякъде в името, а
// застъпващите се участъци се сливат, за да не се влагат <mark> елементи.
import type { ReactNode } from "react";

export const highlightWords = (name: string, words: string[]): ReactNode => {
  if (!words.length) return name;
  const lower = name.toLowerCase();
  const ranges: [number, number][] = [];
  for (const word of words) {
    let index = 0;
    while ((index = lower.indexOf(word, index)) !== -1) {
      ranges.push([index, index + word.length]);
      index += word.length;
    }
  }
  if (!ranges.length) return name;
  ranges.sort((a, b) => a[0] - b[0]);
  const merged: [number, number][] = [];
  for (const range of ranges) {
    const last = merged[merged.length - 1];
    if (last && range[0] <= last[1]) last[1] = Math.max(last[1], range[1]);
    else merged.push([range[0], range[1]]);
  }
  const out: ReactNode[] = [];
  let position = 0;
  merged.forEach(([start, end], i) => {
    if (start > position) out.push(name.slice(position, start));
    out.push(
      <mark key={i} className="bg-transparent font-bold text-brand-deep-ink">
        {name.slice(start, end)}
      </mark>,
    );
    position = end;
  });
  if (position < name.length) out.push(name.slice(position));
  return out;
};
